{
  "MaxfilterlistlimitLabel": "Limite maximale de la liste de filtres :",
  "MaxreportrowdisplimitLabel": "Limite maximale d'affichage des lignes du rapport :",
  "MaxfilterlistlimitPlaceholder": "150",
  "MaxreportrowdisplimitPlaceholder": "150",
  "ContentRestriction_SectionHeader": "Restriction du contenu",
  "ContentRestriction_SectionPara": "Pour les environnements comportant un grand nombre de dispositifs et\/ou d'agents ACD, vous pouvez augmenter le nombre maximal de numéros d'appel d'urgence. ",
  "NAME": "ContentRestriction"
}